import { createClient } from "@supabase/supabase-js";

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

// When the app is run without a configured Supabase project (e.g. local dev
// before SETUP.md has been followed, or someone just cloning the repo), the
// whole app must still work in guest mode. `supabase` is null in that case —
// every caller must check for that before using it.
export const supabase = url && anonKey ? createClient(url, anonKey) : null;
